import React from 'react';
import DatePicker from "react-datepicker";
import { useState, useContext } from 'react';
import { Modal, Button, Row, Col, Alert } from 'react-bootstrap';
import PortalDataService from '../../../../services/portal.service';
import StateContext from '../../../../context/State';
import { evenTimes, oddTimes } from '../../../../data';
import { convertFrom24To12Format, convertTime12to24 } from '../../../../../../util/genericDateAndTimeFuncs';


export type ScheduleSigningProps = {
    setScheduledTime: (arg0: string) => void;
    onHideModal: () => void;
    getRemoteSigningSchedule: () => void;
    showModal: boolean;
}

const ScheduleSigning = (props: ScheduleSigningProps) => {

    const { state } = useContext(StateContext);
    const lawyerService = new PortalDataService(state);

    const [date, setDate] = useState<Date>(new Date());
    const [sessionEndTime, setSessionEndTime] = useState<string>('');
    const [sessionStartTime, setSessionStartTime] = useState<string>('');

    const saveSessionDateTime = () => {

        if (sessionStartTime === '' || sessionEndTime === '') {
            alert('Please select a valid start and end time before saving.');
            return;
        }

        const startDateTime: string = date.toISOString().slice(0, 10) + ' ' + sessionStartTime + ':00.000';
        const endDateTime: string = date.toISOString().slice(0, 10) + ' ' + sessionEndTime + ':00.000';
        const scheduledTime = `${date.toLocaleDateString()} from ${convertFrom24To12Format(sessionStartTime)} to ${convertFrom24To12Format(sessionEndTime)}`
        lawyerService.setSessionDateTime(state.portalId, { startDateTime, endDateTime })
            .then(() => {
                alert('Scheduled!');
                props.setScheduledTime(scheduledTime)
                // MODAL GOES HERE
                props.onHideModal();
                props.getRemoteSigningSchedule();
            })
            .catch(err => { alert('Unable to Schedule a Remote Signing Session'); console.log(err) });
    }


    const getSessionLengths = (sessionTime: string): string[] => {
        const time = new Date();
        let [hours, minutes] = sessionTime.split(':');
        let numHours = parseInt(hours);
        let numMinutes = parseInt(minutes);

        time.setHours(numHours);
        time.setMinutes(numMinutes);

        const plusThirty = `${(time.getMinutes() === 30) ? time.getHours() + 1 : time.getHours()}:${(time.getMinutes() === 0) ? '30' : '00'}`;
        const plusOne = `${(time.getMinutes() === 30) ? time.getHours() + 1 : time.getHours() + 1}:${(time.getMinutes() === 0) ? '00' : '30'}`;
        const plusOneThirty = `${(time.getMinutes() === 30) ? time.getHours() + 2 : time.getHours() + 1}:${(time.getMinutes() === 0) ? '30' : '00'}`;
        const plusTwo = `${(time.getMinutes() === 30) ? time.getHours() + 2 : time.getHours() + 2}:${(time.getMinutes() === 0) ? '00' : '30'}`;

        return [plusThirty, plusOne, plusOneThirty, plusTwo]
    }

    return (
        <>
            <Modal
                show={props.showModal}
                onHide={props.onHideModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="schedule-session-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">Schedule Session</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Alert>Schedule session at <b>{date.toDateString()}</b> {(sessionStartTime === '' ? '' : 'from')} <b>{(sessionStartTime === '' ? '' : convertFrom24To12Format(sessionStartTime.toString()))}</b> {(sessionEndTime === '' ? '' : 'to')} <b>{(sessionEndTime === '' ? '' : convertFrom24To12Format(sessionEndTime.toString()))}</b></Alert>

                    <Row>
                        <Col className="col-5">
                            <DatePicker
                                className="session"
                                selected={date}
                                minDate={new Date()}
                                onChange={(newDate) => { setDate(newDate) }}
                                inline
                            />
                        </Col>

                        <Col className="col-7">
                            {sessionStartTime !== ''
                                ?
                                <>
                                    {sessionEndTime === '' && <Alert variant="secondary">Please select an <b>end</b> time.</Alert>}

                                    <Row>
                                        <Col className="col-3">
                                            {(sessionEndTime === '') && getSessionLengths(sessionStartTime).map((time, index) => {
                                                return (
                                                    <React.Fragment key={index + '-session-end-times'}>
                                                        <Button
                                                            key={index + '-session-end-button'}
                                                            onClick={() => setSessionEndTime(time)}
                                                            style={{margin:'3px', width:'90px'}}
                                                            variant="secondary"
                                                        >
                                                            {convertFrom24To12Format(time)}
                                                        </Button>
                                                    </React.Fragment>
                                                )
                                            })}
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs={3}>
                                            <Button
                                                variant="outline-primary"
                                                style={{margin:'3px', width:'90px'}}
                                                onClick={() => {
                                                    setSessionStartTime('');
                                                    setSessionEndTime('')
                                                }}
                                            >Edit Time(s)</Button>
                                        </Col>
                                    </Row>
                                </>
                                :
                                <>
                                    <Alert variant="secondary">Please select a <b>Start</b> time.</Alert>
                                    <Row>
                                        <Col className="col-3">
                                            {evenTimes.map((time, index) => {
                                                return (
                                                    <React.Fragment key={index + '-even-times'}>
                                                        <Button
                                                            key={index + '-even-button'}
                                                            variant="secondary"
                                                            style={{margin:'3px', width:'90px'}}
                                                            onClick={() => setSessionStartTime(convertTime12to24(time))}
                                                        >
                                                            {time}
                                                        </Button>
                                                    </React.Fragment>
                                                )
                                            })}
                                        </Col>

                                        <Col className="col-3">
                                            {oddTimes.map((time, index) => {
                                                return (
                                                    <React.Fragment key={index + '-odd-times'}>
                                                        <Button
                                                            key={index + '-odd-button'}
                                                            variant="secondary"
                                                            style={{margin:'3px', width:'90px'}}
                                                            onClick={() => setSessionStartTime(convertTime12to24(time))}
                                                        >
                                                            {time}
                                                        </Button>
                                                    </ React.Fragment>
                                                )
                                            })}
                                        </Col>
                                    </Row>
                                </>
                            }
                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer>
                    {sessionStartTime && sessionEndTime !== ''
                        ?
                        <>
                            <Button
                                variant="primary"
                                onClick={() => saveSessionDateTime()}
                            >Schedule</Button>
                        </>
                        :
                        <>
                            <Button
                                variant="secondary"
                            >Schedule</Button>
                        </>
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ScheduleSigning;
